export default "__VITE_ASSET__Dvwt0bXh__"